<button class="ion-float-right primary button" [disabled]="disabled" (click)="stopPatientCall()">
  Stop & Review
</button>
